module.exports = __webpack_public_path__ + "static/media/06_icon-burnaby.7c2b8dc5.jpg";